import { Model } from "vuex-fetch-factory";
import { TermRaw, TermModel } from "./term";
import moment from "moment";

export interface ProjectRaw {
  id: number;
  relation_id: number;
  description: string;
  start_date: string;
  end_date: string;
  terms: TermRaw[] | null;
}

export class ProjectModel implements Model<ProjectModel, ProjectRaw> {
  private id = 0;
  private relation_id = 0;
  private description = "";
  private start_date = "";
  private end_date = "";
  private terms: TermModel[] = [];

  public getNew(): ProjectModel {
    return new ProjectModel();
  }

  public fillModel(raw: ProjectRaw): this {
    this.id = raw.id;
    this.relation_id = raw.relation_id;
    this.description = raw.description;
    this.start_date = raw.start_date;
    this.end_date = raw.end_date;

    if (raw.terms !== null) {
      this.terms = raw.terms.map((t): TermModel => {
        const nt = new TermModel();
        nt.fillModel(t);
        return nt;
      });
    }

    return this;
  }

  public getRaw(): ProjectRaw {
    return {
      id: this.id,
      relation_id: this.relation_id,
      description: this.description,
      start_date: this.start_date,
      end_date: this.end_date,
      terms: this.terms.map((t): TermRaw => {
        return t.getRaw();
      }),
    };
  }

  public get projectId(): number {
    return this.id;
  }

  public isActive(): boolean {
    const format = "YYYY-MM-DD";
    const start = moment(this.start_date, format);

    if (!start.isBefore(moment())) return false;

    if (this.end_date === "") return true;

    const end = moment(this.end_date, format);
    return end.isAfter(moment());
  }
}
